import React from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { theme } from "@packsize/theme";

import { storagePrefix } from "./environment";

interface ThemeProviderProps {
	readonly children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
	return (
		<MuiThemeProvider theme={theme} defaultMode="light" modeStorageKey={`${storagePrefix}color-mode`} noSsr>
			<CssBaseline />
			{children}
		</MuiThemeProvider>
	);
};
